<template>
  <client-only>
    <div class="relative">
      <div ref="google-login-button" class="w-10 h-10 z-10 flex justify-center items-center"></div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { useGoogleLogin } from '@/composables/useGoogleLogin'
import { useLoginSdkInit } from '@/composables/useLoginSdkInit'

const googleLoginBtnRef = useTemplateRef('google-login-button')
const { isGoogleReady, initialize, renderButton } = useGoogleLogin()
const i18n = useI18n()

useLoginSdkInit(() => {
  initialize()
})

watchDebounced(
  [isGoogleReady, googleLoginBtnRef],
  ([isReady, btnEl]) => {
    if (isReady && btnEl) {
      renderButton(btnEl, {
        type: 'icon',
        text: 'signin_with',
        locale: i18n.locale.value,
      })
    }
  },
  { immediate: true, debounce: 10 }
)
</script>
